<div class="instrument-page overflow-hidden bg-[#fffcfa] text-[#221611]">
    <section
        class="relative overflow-hidden bg-[linear-gradient(180deg,#1c0905_0%,#77270b_42%,#c44b14_76%,#db6322_100%)] text-white">
        <div class="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-b from-transparent to-[#fffcfa]"></div>
        <img
            src="../../assets/images/instrument/CalligraphyCharacters001-boosted.png"
            alt=""
            class="hero-calligraphy-image pointer-events-none absolute left-[2%] top-24 z-0 w-7 opacity-[0.1] md:left-[4%] md:w-10 md:opacity-[0.12] lg:w-12">
        <img
            src="../../assets/images/instrument/CalligraphyCharacters003-boosted.png"
            alt=""
            class="hero-calligraphy-image pointer-events-none absolute left-[19%] top-16 z-0 hidden w-6 opacity-[0.07] md:block lg:w-7">
        <img
            src="../../assets/images/instrument/CalligraphyCharacters007-boosted.png"
            alt=""
            class="hero-calligraphy-image pointer-events-none absolute right-[2%] top-16 z-0 w-7 opacity-[0.1] md:right-[4%] md:w-10 md:opacity-[0.12] lg:w-12">
        <img
            src="../../assets/images/instrument/CalligraphyCharacters004-boosted.png"
            alt=""
            class="hero-calligraphy-image pointer-events-none absolute right-[19%] top-36 z-0 hidden w-6 opacity-[0.07] md:block lg:w-7">
        <img
            src="../../assets/images/instrument/CalligraphyCharacters005-boosted.png"
            alt=""
            class="hero-calligraphy-image pointer-events-none absolute left-[25%] top-52 z-0 hidden w-5 opacity-[0.05] md:block lg:w-6">
        <img
            src="../../assets/images/instrument/CalligraphyCharacters006-boosted.png"
            alt=""
            class="hero-calligraphy-image pointer-events-none absolute right-[25%] top-58 z-0 hidden w-5 opacity-[0.05] md:block lg:w-6">

        <div class="relative z-10 mx-auto flex min-h-[560px] max-w-6xl items-center px-6 pb-28 pt-28 md:min-h-[680px] md:px-10 md:pb-36 md:pt-36">
            <div class="mx-auto max-w-3xl text-center">
                <p
                    class="mb-6 inline-flex rounded-full border border-white/15 bg-white/10 px-4 py-2 text-[12px] font-semibold uppercase tracking-[0.28em] text-white/85">
                    Instrument VDP
                </p>
                <h1 class="mx-auto max-w-2xl text-4xl font-bold leading-[1.08] md:text-[68px]">
                    丹书<span class="text-[#ffd3c5]">·</span>智能高效的 PDF<br class="hidden md:block">
                    编辑器
                </h1>
<p class="mx-auto mt-6 max-w-2xl text-sm leading-6 text-white/78 md:text-base md:leading-7">
    针对 PDF 编辑与文档设计场景打造，兼顾清晰排版、稳定输出与高效协作，帮助团队更轻松地完成制作、修改与交付。
</p>

<div class="mt-8 flex flex-wrap items-center justify-center gap-3">
    <button
        class="rounded-lg bg-white px-5 py-1.5 text-xs font-semibold text-[#7f2c0d] shadow-[0_12px_30px_rgba(32,10,3,0.14)] transition hover:-translate-y-0.5"
        (click)="openTrialPage()">
        申请试用
    </button>
    <button
        class="rounded-lg border border-white/25 bg-white/10 px-5 py-1.5 text-xs font-semibold text-white transition hover:bg-white/16"
        (click)="openContactPage()">
        联系我们
    </button>
                </div>
            </div>
        </div>
    </section>

    <!-- <div class="instrument-cover-dragons hidden md:block" aria-hidden="true">
        <div class="dragon-stage mx-auto max-w-[1280px]">
            <img
                src="../../assets/images/instrument/dragon.svg"
                alt=""
                class="dragon-left pointer-events-none absolute">
            <img
                src="../../assets/images/instrument/dragon.svg"
                alt=""
                class="dragon-right pointer-events-none absolute">
        </div>
    </div> -->

    <section class="instrument-cover-section relative z-10 -mt-20 px-4 md:-mt-28 md:px-8">
        <div class="mx-auto max-w-[1280px]">
            <mat-card class="instrument-video-card">
                <div class="instrument-video-cover">
                    <img
                        src="../../assets/images/instrument/instrument_cover.png"
                        alt="丹书 Instrument 封面界面"
                        class="block w-full rounded-[20px] md:rounded-[24px]">
                </div>
            </mat-card>
        </div>
    </section>

    <section class="px-5 pb-8 pt-16 md:px-8 md:pb-12 md:pt-24">
        <div class="mx-auto max-w-3xl text-center">
            <h2 class="text-[32px] font-bold leading-tight text-[#1e1410] md:text-[56px]">
                掌控文档每一步，就从<span class="text-[#cf5420]">丹书</span>开始
            </h2>
            <p class="mx-auto mt-5 max-w-2xl text-sm leading-7 text-[#6f5a52] md:text-[17px]">
                面向日常设计改稿、资料整编、说明书维护和标准化输出场景，丹书提供更稳定、更易协作的 PDF 工作方式。
            </p>
        </div>
    </section>

    <section class="px-[20px] pb-[44px] md:px-[32px] md:pb-[72px]">
        <div class="mx-auto flex max-w-[1280px] flex-col gap-[72px] md:gap-[92px]">
            <ng-container *ngFor="let feature of featureItems; let i = index">
                <div
                    class="feature-row grid items-center gap-[26px] md:gap-[48px]"
                    [ngClass]="feature.reverse ? 'feature-row-reverse' : ''">
                    <div
                        class="feature-copy order-2 flex h-full flex-col justify-center"
                        [ngClass]="feature.reverse ? 'md:order-1' : 'md:order-2'">
                        <div class="mb-[14px] inline-flex w-fit self-start items-center gap-[8px] rounded-full border border-[#f2b9a5] bg-[#fff7f3] px-[12px] py-[6px] text-[12px] font-semibold leading-none text-[#d15423]">
                            <img src="../../assets/images/instrument/instrument_icon.svg" alt="" class="h-[14px] w-[14px]">
                            {{ feature.kicker }}
                        </div>
                        <h3 class="text-[28px] font-bold leading-[1.16] tracking-[-0.02em] text-[#17100d] md:text-[38px]">
                            {{ feature.title }}
                        </h3>
                        <p class="mt-[14px] text-[15px] leading-[28px] text-[#5f4d47] md:text-[16px] md:leading-[30px]">
                            {{ feature.description }}
                        </p>
                        <div class="feature-bullet-row mt-[18px]">
                            <ul class="feature-bullet-list text-[15px] leading-[28px] text-[#463633] md:text-[16px] md:leading-[30px]">
                                <li *ngFor="let bullet of feature.bullets" class="flex items-start gap-[14px]">
                                    <span class="mt-[11px] h-[6px] w-[6px] shrink-0 rounded-full bg-[#cf5420]"></span>
                                    <span class="block">{{ bullet }}</span>
                                </li>
                            </ul>
                            <button
                                class="feature-arrow-button flex h-[42px] w-[42px] items-center justify-center rounded-[14px] bg-[#cf5420] text-[18px] text-white shadow-[0_10px_22px_rgba(207,84,32,0.18)] transition hover:-translate-y-0.5"
                                (click)="openContactPage()">
                                ↗
                            </button>
                        </div>
                    </div>

                    <div
                        class="feature-media order-1"
                        [ngClass]="feature.reverse ? 'md:order-2' : 'md:order-1'">
                        <div class="feature-card-shell">
                            <div class="feature-card-frame">
                            <div class="feature-canvas relative overflow-hidden rounded-[22px] border border-[#f1c8bc] bg-white shadow-[0_14px_32px_rgba(114,44,18,0.06)]">
                                <div
                                    class="pointer-events-none absolute right-0 top-0 h-full rounded-r-[22px] bg-[linear-gradient(180deg,#f0c9be_0%,#f7dcd5_100%)]">
                                </div>
                                <img
                                    [src]="feature.image"
                                    [alt]="feature.imageAlt"
                                    class="block w-full rounded-[18px]">
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </section>

    <section class="py-10 md:py-16 max-w-[1440px] center">
        <div
            class="quote-radiant mx-auto max-w-6xl rounded-[36px] border border-[#f1ddd6] bg-[linear-gradient(180deg,#fff8f5_0%,#f9e5dc_100%)] px-6 py-14 text-center md:px-12 md:py-12">
            <p class="mx-auto max-w-4xl text-[30px] font-bold leading-tight text-[#231612] md:text-[52px]">
                “精准设计，完美呈现一丝不苟的<br class="hidden md:block">
                创意在 PDF 中绽放光彩。”
            </p>
            <p class="mt-4 text-sm text-[#86695d] md:text-base">以更清晰的编辑体验，让修改、定稿与交付更顺畅。</p>
            <button
                class="mt-8 rounded-full bg-[#cf5420] px-6 py-1 text-sm font-semibold text-white shadow-[0_16px_30px_rgba(207,84,32,0.24)] transition hover:-translate-y-0.5"
                (click)="openTrialPage()">
                立即试用
            </button>
        </div>
    </section>

    <section class="bg-[#190d0a] px-5 pt-4 text-white md:px-8 md:pt-8">
        <div class="max-w-[1440px] center">
            <h2 class="text-center text-[30px] font-bold leading-tight md:text-[54px] max-w-[600px] center">
                <span class="text-[#ff7f45]">light/dark</span> 模式，只为<br class="md:hidden">
                了打造更好的用户体验
            </h2>
            <div class="mx-auto mt-12 max-w-5xl">
                <app-image-comparison
                    [originalImage]="'../../assets/images/instrument/dark.png'"
                    [effectImage]="'../../assets/images/instrument/light.png'"
                    [originalAlt]="'丹书 dark 模式界面'"
                    [effectAlt]="'丹书 light 模式界面'"
                    [initialSlider]="50">
                </app-image-comparison>
            </div>
        </div>
    </section>

    <section class="px-5 py-16 md:px-8 md:py-24">
        <div class="max-w-[1440px] center ">
            <div class="text-center">
                <p class="mb-4 inline-flex items-center gap-2 rounded-full border border-[#f1b8a4] bg-[#fff7f4] px-3 py-1 text-[12px] font-semibold text-[#cf5420]">
                    <img src="../../assets/images/instrument/instrument_icon.svg" alt="" class="h-3.5 w-3.5">
                    为文档工作而生
                </p>
                <h2 class="text-[32px] font-bold leading-tight text-[#1f1411] md:text-[56px]">
                    一站式 PDF 解决方案，<br class="hidden md:block">
                    就在<span class="text-[#cf5420]">丹书</span>
                </h2>
                <p class="mx-auto mt-5 max-w-3xl text-sm leading-7 text-[#6f5a52] md:text-[17px]">
                    从页面编辑、内容调整到文档交付，丹书帮助团队把 PDF 工作流程梳理得更稳定、更高效，也更适合长期协作。
                </p>
            </div>

            <div class="instrument-reason-cards mt-12">
                <ng-container *ngFor="let item of capabilityItems; let i = index">
                    <div class="instrument-adv-card" (mouseenter)="onMouseEnter(i, $event)" (mouseleave)="onMouseLeave(i)"
                        (mousemove)="onMouseMove($event, i)">
                        <div class="light-ball" *ngIf="item.isHovered"
                            [ngStyle]="{'transform': 'translate3d(' + item.position.x + 'px, ' + item.position.y + 'px, 0)'}">
                        </div>
                        <img [src]="item.icon" alt="" class="instrument-adv-icon">
                        <h3>{{ item.title }}</h3>
                        <p>{{ item.description }}</p>
                    </div>
                </ng-container>
            </div>
        </div>
    </section>

</div>
